
export function getPermissions(user_type) {
    if (user_type == 1) {
        return type.accountant_user;
    }
    else if (user_type == 2) {
        return type.viewer_user;
    } else {
        return type.accountant_user;
    }
}

const type = {
    accountant_user: {
        bond:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        entry:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        account: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        daily_table: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        statement: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        custom_statement: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        trial_balance: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        final_account: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        currency: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        financial_file: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        user: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        user_preferences: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        warehouse: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        invoice: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        statistics: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        matching_table:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        unit_size:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        material:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        inventory:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        materials_journal:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        manufacturing_bond:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        manifest:{
            properties: {},
            actions: {
                get: true
            }
        },
        tree:{
            properties: {},
            actions: {
                export_as_pdf: true
            }
        }
    },
    viewer_user: {
        
        bond:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
            }
        },
        entry:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        account: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        daily_table: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true
            }
        },
        statement: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true
            }
        },
        custom_statement: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true,
            }
        },
        trial_balance: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true
            }
        },
        final_account: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true
            }
        },
        currency: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        financial_file: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        user: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
            }
        },
        user_preferences: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        warehouse: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        invoice: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        statistics: {
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        matching_table:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        unit_size:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        material:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        inventory:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true,
                export_as_pdf: true
            }
        },
        materials_journal:{
            properties: {},
            actions: {
                create: false,
                edit: false,
                delete: false,
                get: true
            }
        },
        manufacturing_bond:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        manifest:{
            properties: {},
            actions: {
                get: true
            }
        },
        tree:{
            properties: {},
            actions: {
                export_as_pdf: true
            }
        }
    }
};